module.exports = __webpack_public_path__ + "static/img/客户墙00044.2364421.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/客户墙00044.png
// module id = S/eU
// module chunks = 1